import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'react-bootstrap';

import { getMessage } from '../../selectors/message';

import classes from './message.module.scss';

export const Message: FunctionComponent = () => {
  const { show, message, type } = useSelector(getMessage);

  if (!show) {
    return null;
  }

  return (
    <Alert className={classes.message} variant={type}>
      {message}
    </Alert>
  );
};
